<template>
  <article class="center" itemprop="articleBody">
    <header>
      <h1>Du hast es geschafft!</h1>
      <h2>Dein Lerncheck ist hiermit abgeschlossen. Die Ergebnisse hast du soeben per Mail erhalten.</h2>
    </header>
    <h2>Lernlücken entdeckt?</h2>
    <p>Dann sichere dir jetzt die passende Unterstützung im Fach {{ category }}!</p>
    <a href="https://shop.studyhelp.de/" target="_blank">
      <img src="/static/shop.png" alt="Lernhefte von StudyHelp" title="Lernhefte von StudyHelp">
    </a>
    <div class="buttons">
      <router-link :to="{ name: 'home' }" class="cta-button"><span>Erneut testen</span></router-link>
    </div>
  </article>
</template>

<style language="scss" scoped>
  h1 {
    color: black;
  }
  h2 {
    color: black;
    margin-top: 50px;
  }
  .center {
    text-align:center;
  }
  .buttons {
    justify-content: center;
  }
  a > img {
    margin-top: 50px;
    box-shadow: 10px 5px 5px lightgrey;
  }
</style>

<script>
    export default {
        data() {
          return {
            category: 'Mathe'
          }
        },
        mounted() {
          this.category = this.$store.getters.activeQuestion.category.name;
          this.$store.dispatch('updateExam', null)
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/FinishExam.vue